import { useMemo } from 'react';
import { AlertStatus } from 'modules/campaigns/alerts/constants';
import { useProjectCampaignAlertsQuery } from 'modules/campaigns/alerts/hooks/useProjectCampaignAlertsQuery';

export type UseQueryProjectCampaignAlertsState = ReturnType<typeof useQueryProjectCampaignAlerts>;

export const useQueryProjectCampaignAlerts = () => {
  const projectAlertsQueryOptions = useMemo(
    () => ({
      variables: {
        status: AlertStatus.Enabled,
      },
    }),
    [],
  );

  const { results, ...rest } = useProjectCampaignAlertsQuery(projectAlertsQueryOptions);

  return { ...rest, projectCampaignAlertsByMedium: results };
};
